import { render, staticRenderFns } from "./DebtorIps.vue?vue&type=template&id=2b98efd4&scoped=true&"
import script from "./DebtorIps.vue?vue&type=script&lang=js&"
export * from "./DebtorIps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b98efd4",
  null
  
)

export default component.exports